import { forwardRef } from "react";
import ListSubheader from "@mui/material/ListSubheader";

import css from "./dropdown-multiple.scss";

const DropdownMultipleSubheader = forwardRef(({ option }, ref ) => (
    <ListSubheader ref={ ref } className={ css.menuSubheader } disableSticky>{ option.label }</ListSubheader>
));

export default DropdownMultipleSubheader;